export default "__VITE_ASSET__BvX1rn$B__"